import axios from 'axios'

/**
 * Soft deletes a promotion from the backend API by id.
 * @param {object} data - The data object with the promotion id and the notify method for alerts.
 */
export default function deletePromotion ({ commit, state, dispatch }, data) {
  axios.delete(`${process.env.VUE_APP_API_URL}api/promotions/${data.promotion_id}`, {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': localStorage.getItem('user-token')
    }
  })
    .then(function (response) {
      dispatch('getAdminPromotions')

      data.notify({
        group: 'foo-velocity',
        title: `Promotion successfully deleted!`,
        text: `<br><br>`,
        type: 'success'
      })
    })
    .catch(function (error) {
      console.log(error)
    })
}
